import { Component, OnInit } from '@angular/core';
import { RegistrationModel } from '../../models/registration-model';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '../../../../node_modules/@angular/router';
import { AuthorisationService } from '../../services/authorisation-service/authorisation-service.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { FormsModule } from '@angular/forms';
import { FieldMatchErrorMatcher } from '../../shared/field-match.directive';
import { UserSessionService } from '../../services/user-session-service/user-session.service';

@Component({
  selector: 'app-portal-new-password',
  templateUrl: './portal-new-password.component.html',
  styleUrls: ['./portal-new-password.component.css']
})
export class PortalNewPasswordComponent implements OnInit {

  registrationModel: RegistrationModel;
  attemptingRegistration: boolean;
  registrationFailed: boolean;
  registrationToken: string;
  generalError: boolean;
  resetPassword: boolean;
  emailAddress: string;
  fieldMatchErrorMatcher = new FieldMatchErrorMatcher();

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router,
    private authorisationService: AuthorisationService, private loggingService: LoggingService, private snackBar: MatSnackBar,
    private userSessionService: UserSessionService) { }

  ngOnInit() {
    this.userSessionService.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(this.appConfigService.ApplicationName, null, null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, false, false, true));
    this.registrationModel = new RegistrationModel();

    this.router.routerState.root.queryParams.subscribe((params) => {
      this.registrationToken = params['token'];
      this.registrationModel.EmailAddress = params['email'];
    });
  }

  // Same process as with registration
  register() {
    this.attemptingRegistration = true;
    this.registrationModel.Token = this.registrationToken;
    this.authorisationService.reset(this.registrationModel).subscribe((response) => {

      // Everything ok
      this.loggingService.log("New password saved successfully", this.appConfigService.LogToConsole);
      let snackbarRef = this.snackBar.open(`New password saved successfully`, "Login", { duration: 3000 });
      snackbarRef.onAction().subscribe((action) => {
        this.router.navigate(['app', 'login']);
      });
      snackbarRef.afterDismissed().subscribe((action) => {
        this.router.navigate(['app', 'login']);
      });
    }, (error) => {
      let httpErrorResponse = error as HttpErrorResponse;
      let snackbarRef;
      switch (httpErrorResponse.status) {
        case 400:
          this.loggingService.log("One or more paramters used for password reset are invalid", this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open("Sorry, something went wrong. Please try again.", "", { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
        case 500:
          this.loggingService.log("Server error during saving new password", this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open("Sorry, something went wrong. Server Error.", "", { duration: 5000 })
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
        case 403:
          this.loggingService.log("Saving new password failed. Email address may be incorrect, or token expired", this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open("Saving new password failed. Please try again.", "", { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;

        default:
          this.loggingService.log("Server could not be contacted", this.appConfigService.LogToConsole);
          snackbarRef = this.snackBar.open("Server unavailable. Please try again later.", "", { duration: 5000 });
          this.attemptingRegistration = false;
          snackbarRef.afterDismissed().subscribe((action) => {
            this.redirectToHome();
          });
          break;
      }
    });
  }

  redirectToHome() {
    this.router.navigate(['app', 'welcome']);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-new-password/portal-new-password.component.ts